import { policyService } from '../../services/PolicyService';
const state = {
    policies: [],
    currentPolicy: null,
    loading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0,
    },
};
const mutations = {
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    SET_POLICIES(state, { policies, pagination }) {
        state.policies = policies;
        state.pagination = pagination;
    },
    SET_CURRENT_POLICY(state, policy) {
        state.currentPolicy = policy;
    },
    UPDATE_POLICY(state, updatedPolicy) {
        const index = state.policies.findIndex((p) => p.id === updatedPolicy.id);
        if (index !== -1)
            state.policies[index] = updatedPolicy;
        if (state.currentPolicy && state.currentPolicy.id === updatedPolicy.id) {
            state.currentPolicy = updatedPolicy;
        }
    },
};
const actions = {
    async createPolicy({ commit }, policyData) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            const response = await policyService.createPolicy(policyData);
            return response;
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to create policy');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async fetchPolicy({ commit }, id) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            const response = await policyService.getPolicy(id);
            commit('SET_CURRENT_POLICY', response.data.data);
            return response;
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to fetch policy');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async updatePolicy({ commit }, { id, data }) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            const response = await policyService.updatePolicy(id, data);
            commit('UPDATE_POLICY', response.data.data);
            return response;
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to update policy');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
};
const getters = {
    policies: (state) => state.policies,
    currentPolicy: (state) => state.currentPolicy,
    loading: (state) => state.loading,
    error: (state) => state.error,
    pagination: (state) => state.pagination,
};
const policy = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
export default policy;
